var _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 48,
    viewBox: "0 0 132 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 130.5,
    height: 46.5,
    rx: 23.25,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 17L67.59 18.41L72.17 23H56V25H72.17L67.58 29.59L69 31L76 24L69 17Z",
    fill: "url(#paint0_linear_4586_7912)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 130.5,
    height: 46.5,
    rx: 23.25,
    stroke: "url(#paint1_linear_4586_7912)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4586_7912",
    x1: 56,
    y1: 17,
    x2: 69.1544,
    y2: 35.7919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032FCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4586_7912",
    x1: 0,
    y1: 0,
    x2: 30.8321,
    y2: 84.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032FCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e2eb5b6a6ba0df3b115152ef3ff067d6.svg";
export { ForwardRef as ReactComponent };